import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../utils/pickIf';
import { styleCondition } from '../../../utils/styleCondition';

export const useStyles = makeStyles()((theme, { isApproved } = {}) => ({
  titleContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: pickIf(isApproved, theme.spacing(3.5), theme.spacing(2)),
    [theme.breakpoints.down('lg')]: {
      marginBottom: pickIf(isApproved, theme.spacing(3), theme.spacing(1)),
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: pickIf(isApproved, theme.spacing(3), 2),
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...styleCondition(theme.isMobileDevice, {
        marginBottom: pickIf(isApproved, theme.spacing(3), theme.spacing(1)),
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        marginBottom: pickIf(isApproved, theme.spacing(3), 2),
        justifyContent: 'flex-start',
      }),
    },
  },
  h1: {
    fontSize: 36,
    [theme.breakpoints.down('lg')]: {
      fontSize: 28,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 22,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...styleCondition(theme.isMobileDevice, {
        fontSize: 28,
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        fontSize: 22,
      }),
    },
  },
  h2: {
    [theme.breakpoints.down('lg')]: {
      fontSize: 18,
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...styleCondition(theme.isMobileDevice, {
        fontSize: 18,
        marginBottom: theme.spacing(1),
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        fontSize: 16,
      }),
    },
  },
  approveText: {
    color: theme.palette.darkGrey,
    fontSize: 18,
    letterSpacing: '0.2px',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(1.5),
    [theme.breakpoints.down('lg')]: {
      fontSize: 16,
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: 14,
      marginTop: 2,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...styleCondition(theme.isMobileDevice, {
        fontSize: 16,
        marginTop: theme.spacing(1),
      }),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...styleCondition(theme.isMobileDevice, {
        fontSize: 14,
        marginTop: 2,
      }),
    },
  },
  fullName: {
    position: 'relative',
    color: '#929A92',
    [theme.breakpoints.down('lg')]: {
      fontSize: 18,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
      marginLeft: theme.spacing(1),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...styleCondition(theme.isMobileDevice, {
        fontSize: 18,
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        fontSize: 12,
        marginLeft: theme.spacing(1),
      }),
    },
  },
  circle: {
    backgroundColor: '#929A92',
    border: '1px solid #929A92',
    borderRadius: '50%',
    height: 1,
    left: -5,
    position: 'absolute',
    top: '50%',
    width: 1,
  },
}));
